var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modal-sinisters-list-component"}},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"})])])
}]

export { render, staticRenderFns }